import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { saveAs } from "file-saver";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";

const descargar = (nombre, texto) => saveAs(new Blob(["﻿" + texto], { type: "text/csv;charset=utf-8" }), nombre);
const filasDe = (r, f) => { try { return r.filas(f) || []; } catch (e) { return []; } };

// Relevamientos de campo: planillas listas para bajar y llenar, precargadas con los datos de la planta (hoja 12).
export function FieldSurveys({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  const [abierta, setAbierta] = useState(null);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const lista = P.relevAplica(f);
        const cats = [...new Set(lista.map((r) => r.cat))];
        const todo = () => descargar(`relevamientos_${f.id}.csv`, lista.map((r) => P.relevCSV(f, r)).join(`\n\n${"=".repeat(90)}\n\n`));
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_surveys_title")}</h3>
            <p className="ep-screen__intro">{t("energy_performance_surveys_intro").replace("{n}", lista.length).replace("{c}", lista.filter((r) => r.crit).length)}</p>
            <div><Button type="button" basic size="small" onClick={todo}><Icon name="download" /> {t("energy_performance_surveys_all")}</Button></div>
            {cats.map((cat) => (
              <section key={cat}>
                <h4 className="ep-section__title">{cat}</h4>
                {lista.filter((r) => r.cat === cat).map((r) => {
                  const filas = filasDe(r, f);
                  return (
                    <div className="ep-section" key={r.id}>
                      <header className="ep-section__header">
                        <h5 className="ep-section__title">{r.nombre} {r.crit && <StatusBadge estado="Brecha mayor">{t("energy_performance_docs_critical")}</StatusBadge>}</h5>
                        <span className="ep-section__note">{r.cols.length} {t("energy_performance_surveys_cols")} · {filas.length} {t("energy_performance_surveys_rows")}</span>
                      </header>
                      <p>{r.obj}</p>
                      <p className="ep-section__note"><strong>{t("energy_performance_surveys_who")}:</strong> {r.quien} · <strong>{t("energy_performance_med_instrument")}:</strong> {r.instr} · <strong>{t("energy_performance_med_frequency")}:</strong> {r.frec}</p>
                      <p className="ep-section__note"><strong>{t("energy_performance_surveys_criterion")}:</strong> {r.crit_ok}</p>
                      <div className="ep-pills">
                        <Button type="button" basic size="mini" aria-expanded={abierta === r.id} onClick={() => setAbierta(abierta === r.id ? null : r.id)}>{t("energy_performance_surveys_view")}</Button>
                        <Button type="button" size="mini" primary onClick={() => descargar(`relevamiento_${r.id}_${f.id}.csv`, P.relevCSV(f, r))}><Icon name="download" /> CSV</Button>
                      </div>
                      {abierta === r.id && (
                        <div className="ep-table">
                          <table>
                            <thead><tr>{r.cols.map((c) => <th key={c}>{c}</th>)}</tr></thead>
                            <tbody>{(filas.length ? filas : Array.from({ length: 4 }, () => r.cols.map(() => ""))).slice(0, 30).map((row, i) => (
                              <tr key={i}>{r.cols.map((_, j) => <td key={j}>{row[j] !== undefined && row[j] !== "" ? row[j] : "—"}</td>)}</tr>
                            ))}</tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  );
                })}
              </section>
            ))}
          </div>
        );
      }}
    </ConInstalacion>
  );
}
